import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { valueByFormikPath } from '../../common'
import { Grid, SemanticWIDTHS } from 'semantic-ui-react'
import { setFieldValue } from '../form/FormikHelpers'
import Button from '../form/Button'
import Checkbox from '../form/Checkbox'

interface CNCDictFormItemProps extends WithTranslation {
    showForm?: boolean,
    unit: any,
    prefix: string,
    formik: any,
    setNewTag: (tag: string) => void
}

class CNCDictFormItem extends Component<CNCDictFormItemProps> {
    render() {
        const { unit, prefix, formik, setNewTag, showForm, t } = this.props
        const fval = valueByFormikPath(prefix, formik.values)
        const ival = valueByFormikPath(prefix, formik.initialValues)
        const state = !fval.active ? (fval.id ? ' delete' : ' ignore') : (fval.id ? '' : ' new')
        return (
            <Grid.Row className={'mcondensed single-item'+state}>
            { showForm ? 
                <Grid.Column width={4}>
                    {unit.form} ({unit.sublemma}\{unit.lemma})
                </Grid.Column>    
            : null }
            <Grid.Column width={6}>
            { fval.active ? 
                <Button type="button" icon="delete" size="mini" color="red" className="checkbox-size"
                    onClick={()=> setFieldValue(formik, prefix+'.active', false, true)}/> 
            : 
                <Button type="button" icon="undo" size="mini" color="yellow" className="checkbox-size"
                    onClick={()=> setFieldValue(formik, prefix+'.active', true, true)}/>
            }
            <span className="taglabel" onClick={() => setNewTag(unit.tag)}>{unit.tag}</span>
            </Grid.Column>
            <Grid.Column width={3}>
            <Checkbox name={prefix+".domain.written"} label={t('written')} fieldProps={{className: "compactfield", disabled: !fval.active}} inputProps={{}}/>
            </Grid.Column>
            <Grid.Column width={3}>
            <Checkbox name={prefix+".domain.spoken"} label={t('spoken')} fieldProps={{className: "compactfield", disabled: !fval.active}} inputProps={{}}/>
            </Grid.Column>
            { showForm ? null :
                <Grid.Column width={4}>
                {ival && fval.lemma !== ival.lemma ? 
                    (<>
                        <Button type="button" size="mini" className='checkbox-size' icon='undo' color='yellow' 
                            onClick={() => setFieldValue(formik, prefix+'.lemma', ival.lemma, true)}/>
                        <span className="changed">&gt; {fval.lemma}</span>
                    </>)
                : <>&nbsp;</> }
                </Grid.Column>
            }
            </Grid.Row>
        )
    }
}

export default withTranslation()(CNCDictFormItem)